import React, { useEffect, useState } from 'react';

const MaintenanceModal = ({ until }: { until: string }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const formattedUntil = new Date(until).toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).replace(',', ' ');

  useEffect(() => {
    // Scroll lock
    document.body.style.overflow = 'hidden';

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const target = new Date(until).getTime();
      const diff = target - now;

      if (diff <= 0) {
        setTimeLeft('00h 00m 00s');
        clearInterval(interval);
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeLeft(
        `${hours.toString().padStart(2, '0')}h ` +
        `${minutes.toString().padStart(2, '0')}m ` +
        `${seconds.toString().padStart(2, '0')}s`
      );
    }, 1000);

    return () => {
      clearInterval(interval);
      document.body.style.overflow = '';
    };
  }, [until]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-xl text-center max-w-md w-full">
        <h2 className="text-2xl font-semibold mb-4 dark:text-white">🔧 Scheduled Maintenance</h2>
        <p className="mb-2 dark:text-gray-300">
          Our website is currently undergoing scheduled maintenance, but we'll be back soon.
        </p>
        <p className="mb-2 dark:text-gray-300">We expect to be back online by:</p>
        <p className="font-bold mb-2 dark:text-white">{formattedUntil}</p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Back online in: <span className="font-mono">{timeLeft}</span>
        </p>
      </div>
    </div>
  );
};

export default MaintenanceModal;
